export default "__VITE_ASSET__BXlSC9Kz__"